import React, { useState } from 'react';
import Button from '../../../../Components/Button/Button';
import useScope from '../../../Scope/Hooks/useScope';
import P1DoctorSetupModal from './P1DoctorSetupModal';

const P1DoctorSetupWrapper: React.FC = () => {
	const { isPoland } = useScope();
	const [isOpen, setIsOpen] = useState(false);

	if (!isPoland) {
		return <></>;
	}

	return (
		<>
			<Button
				onClick={() => setIsOpen(true)}
				title='component.p1DoctorSetup.button'
				theme={'blue'}
				className={'mt-4'}
			/>
			{isOpen && (
				<P1DoctorSetupModal
					isOpen
					onClose={() => setIsOpen(false)}
					onSave={() => setIsOpen(false)}
				/>
			)}
		</>
	);
};

export default P1DoctorSetupWrapper;
